import { CustomerHistoryItem } from "../datatypes/CustomerHistory";
import { bettyBundleIdInsteadOfBundleNumber } from "./articleUtils";
import { chooseBundleToShow } from "./BundleSelectionUtil";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import { ArticleRenderData } from "shared/src/types/RenderData";

const ID_REGEX = "^\\/(\\w+/){2}(.+$)";

const extractId = (sourcePath: string) => {
    // extract ids after the first two groups
    const matchedGroups = sourcePath.match(ID_REGEX);
    return (matchedGroups && matchedGroups[2]) || "";
};

export const parseArticleId = (sourcePath: string) => {
    // sourcePath: /shopflavor/pv/articleNumber/variantNumber/bundleNumber/description
    const matchedGroups = sourcePath.split("/");
    if (!matchedGroups) {
        return null;
    }
    const articleNumber = matchedGroups[3] || "";
    const variantNumber = matchedGroups[4] || "";
    return articleNumber + variantNumber;
};

export const getMappedStoreListItem = (item: CustomerHistoryItem) => {
    // sourcePath: /shopflavor/storelist/id
    return {
        name: item.name,
        type: "STORELIST",
        listId: extractId(item.sourcePath)
    };
};

export const getMappedCategoryItem = (item: CustomerHistoryItem) => {
    // sourcePath: /shopflavor/category/id[/subId_1.../subId_n]
    return {
        name: item.name,
        urlCategoryPath: extractId(item.sourcePath),
        imageUrl: null // a required filed
    };
};

export const getMappedArticleToRender = (
    item: { [x: string]: any } | null | undefined,
    position: number | null | undefined
): ArticleRenderData | null => {
    if (!item) {
        return null;
    }
    return {
        name: item.description,
        url: item.imageUrl,
        variant: item,
        variantId: item.variantId,
        bundles: bettyBundleIdInsteadOfBundleNumber(item.bundles, item.bundles),
        bundleSelector: bettyBundleIdInsteadOfBundleNumber(item.bundles, item.bundleSelector),
        selectedBundle: chooseBundleToShow(item.bundles, SessionStore.getCustomerStore()),
        position: position
    };
};
